/**
 * Error Model - Centralized error type definitions
 * Used across all pages for consistent error handling
 */

export type ErrorType = 'error' | 'warning' | 'info' | 'success';

export interface AppError {
  code: string;
  type: ErrorType;
  title: string;
  message: string;
  targetPage?: string; // Where this error should be displayed
  params?: Record<string, any>; // Additional parameters
  dismissible?: boolean;
  timestamp?: number;
}

/**
 * NHS-specific error codes
 */
export enum NhsErrorCode {
  ACCOUNT_EXISTS = 'nhs_account_account_exists',
  NAME_MISMATCH = 'nhs_account_name_mismatch',
  NOT_REGISTERED = 'nhs_account_not_registered',
  CONSENT_NOT_GIVEN = 'ConsentNotGiven',
  AGE_RESTRICTION = 'age18',
  RECURRING_USER = 'recurringNhsUser',
  LOGIN_REQUIRED = 'nhs_login_required',
  CANNOT_LOGIN = 'cannotlogin',
  NHS_ACCOUNT_LINKED = 'nhs_account'
}

/**
 * Backend error codes
 */
export enum BackendErrorCode {
  EMAIL_NOT_FOUND = 'email_not_found',
  INCORRECT_PASSWORD = 'incorrect_password',
  MFA_CODE_ERROR = 'mfa_code_error',
  FORGOT_SUCCESS = 'forgot_success'
}

/**
 * All error codes union type
 */
export type ErrorCode = NhsErrorCode | BackendErrorCode | string;
